/**
 * 工作人员相关接口
 */
import request from '../utils/axios'

// 获取工作人员根据部门Id
export function GetStaffByDepartmentId(id) {
  return request({
    url: `/Staff/GetStaffByDepartmentId?id=${id}`,
    method: 'get'
  })
}

// 手机验证码登录（工作人员）
export function LoginCodeByStaff(params) {
  return request({
    url: `/Staff/LoginCode`,
    method: 'post',
		data:params
  })
}

// 发送手机验证码（工作人员）
export function getCodeByStaff(params) {
  return request({
    url: '/Staff/SendSms',
    method: 'post',
		data:params
  })
}

// 获取工作人员列表
export function GetList(params) {
  return request({
    url: `/Staff/GetList`,
    method: 'post',
		data:params
  })
}

// 添加工作人员
export function AddnewUser(params) {
  return request({
    url: `/Staff/AddnewUser`,
    method: 'post',
		data:params
  })
}

// (管理员)修改工作人员
export function UpdateStaff(params) {
  return request({
    url: `/Staff/UpdateStaff`,
    method: 'post',
		data:params
  })
}

// (管理员)获取工作人员详情
export function GetStaffDetails(userKey) {
  return request({
    url: `/Staff/GetStaffDetails?userKey=${userKey}`,
    method: 'get'
  })
}


// 获取自己用户详情(工作人员)
export function GetDetails() {
  return request({
    url: `/Staff/GetDetails`,
    method: 'get'
  })
}

// 移动修改部门（工作人员）
export function UpdateDepartmentByMove(params) {
  return request({
    url: `/Staff/UpdateDepartmentByMove`,
    method: 'post',
		data:params
  })
}

// 获取前端部门人员树状（工作人员）
export function GetDepartmentUser() {
  return request({
    url: `/Staff/GetDepartmentUser`,
    method: 'get'
  })
}

// 按原始密码更改密码（工作人员）
export function ChangePasswordByOriginal(params) {
  return request({
    url: `/Staff/ChangePasswordByOriginal`,
    method: 'post',
		data:params
  })
}

// 修改地图派账号密码（工作人员）
export function UpdateMapUser(params) {
  return request({
    url: `/Staff/UpdateMapUser`,
    method: 'post',
		data:params
  })
}

// 前端每60分钟对接一次地图派token (工作人员)
export function GetMyMapToken(params) {
  return request({
    url: `/Staff/GetMyMapToken?token=${params}`,
    method: 'get'
  })
}

//  更改用户密码，根据验证码生成的key（工作人员）
export function ChangePasswordForceByStaff(data) {
  return request({
    url: `/Staff/ChangePasswordForce`,
    method: 'post',
		data
  })
}

// 返回地图派树状菜单（工作人员）
export function GetMapuserTreeList() {
  return request({
    url: `/Staff/GetMapuserTreeList`,
    method: 'get'
  })
}

// 删除工作人员
export function DeleteStaff(delcode){
	return request({
		url: `/Staff/DeleteStaff?delcode=${delcode}`,
		method: 'get'
	})
}

// 获取自己管理辖区下区域信息(工作人员)
export function GetMyJurisdictionArea(delcode){
	return request({
		url: `/Staff/GetMyJurisdictionArea`,
		method: 'get'
	})
}

